import { Injectable } from '@angular/core';
import { AnnualPlan } from "../../common/models/annual-plan";
import { Week } from "../../common/models/week";
import { ExerciceCategory } from "../../common/models/exercice-category";
import { AnnualPlanPhase } from "../../common/models/annual-plan.phase";
import { AnnualPlanMacroCycle } from "../../common/models/annual-plan-macro-cycle";
import { MacroCycle } from "../../common/models/macro-cycle";
import { Phase } from "../../common/models/phase";

@Injectable({providedIn: 'root'})
export class AnnualPlanDataMerger {
    public mergeEffectiveData(data: any): AnnualPlanEffectiveData {
        return data;
    }

    public mergeData(data: any): AnnualPlanData {
        const objectData: AnnualPlanData = {plan: null, weeks: null, phases: null, macroCycles: null};

        if (data['annualPlan']) {
            const plan = AnnualPlan.fromAPI(data['annualPlan']);
            Object.assign(objectData, {plan});
        }

        if (data['weeks']) {
            const weeks = data['weeks'].map((weekData:any) => {
                const week = Week.fromAPI(weekData);

                // "join" exercise categories on each weeks
                if (weekData['exerciseCategories']) {
                    Object.assign(week, {
                        exerciseCategories: weekData['exerciseCategories'].map(
                            (exCatData:any) => ExerciceCategory.fromAPI(exCatData)
                        )}
                    );
                }

                return week;
            });

            Object.assign(objectData, {weeks});
        }

        if (data['phases']) {
            const phases = data['phases'].map((d:any) => Object.assign(
                AnnualPlanPhase.fromAPI({
                    id: d.annualPlanPhaseId,
                    weekFrom: d.annualPlanPhaseWeekFrom,
                    weekTo: d.annualPlanPhaseWeekTo
                }), {
                    phase: Phase.fromAPI({
                        id: d.phaseId,
                        hexadecimalColor: d.phaseHexadecimalColor
                    }, [{
                        phaseId: d.phaseTranslationPhaseId,
                        name: d.phaseTranslationName
                    }])
                }));

            Object.assign(objectData, {phases});
        }

        if (data['macroCycles']) {
            const macroCycles = data['macroCycles'].map((d:any) => Object.assign(
                AnnualPlanMacroCycle.fromAPI({
                    id: d.annualPlanMacroCycleId,
                    weekFrom: d.annualPlanMacroCycleWeekFrom,
                    weekTo: d.annualPlanMacroCycleWeekTo
                }, d.translationsData), {
                    macroCycle: MacroCycle.fromAPI({
                        id: d.macroCycleId,
                        hexadecimalColor: d.macroCycleHexadecimalColor
                    }, [{
                        macroCycleId: d.macroCycleTranslationMacroCycleId,
                        name: d.macroCycleTranslationName
                    }])
                }));

            Object.assign(objectData, {macroCycles});
        }

        return objectData;
    }
}

export interface AnnualPlanData {
    plan: any;
    weeks: any;
    phases: any;
    macroCycles: any;
}

export interface AnnualPlanEffectiveData {
    weeks: EffectiveWeek[];
}

export interface EffectiveWeek {
    id: number;
    realWeekNumber: number;
    intensityPercent: number;
    sort: number;
    weekNumber: number;
    accents: any[];
    firstDayOfWeek: number;
    lastDayOfWeek: number;
    comment: string;
}
